module.exports = __webpack_public_path__ + "img/Group-4215.888a1ea4.svg";